import { useEffect, useState } from "react";
import type { AuthenticatedUser } from "~/models/auth";
import PublicLeagueCardView from "~/components/cards/PublicLeagueCardView";
import { PublicLeagueBettingPoolWithBetCount } from "~/services/league/leagueTypes";

interface Props {
  league: PublicLeagueBettingPoolWithBetCount;
  user: AuthenticatedUser | null;
}
export default function PublicLeagueCard({ league, user }: Props) {
  const now = new Date().getTime();
  const closingTime = new Date(league.closing_date_time ?? new Date()).getTime();
  

  const [buttonState, setButtonState] = useState<
    "loading" | "leaderboard" | "join"
  >("loading");

  useEffect(() => {
    
    if (now > closingTime) {
      setButtonState("leaderboard");
      return;
    }

    if (user && user.id) {
      fetch("/resources/hasUserBetOnLeague", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          leagueId: league.id,
        }),
      })
        .then((data) => data.json())
        .then((res) => {
          if (res.success) {
            const hasBet = res?.payload?.hasBet === true;
            setButtonState(hasBet ? "leaderboard" : "join");
          } else {
            setButtonState("leaderboard");
          }
        });
    } else if (user === null) {
      setButtonState("join");
    }
  }, [user, league, now, closingTime]);

  return <PublicLeagueCardView league={league} buttonState={buttonState} />;
}
